import "./patchHistory.js"; // side-effect
import type { PushStateEvent, ReplaceStateEvent } from "./patchHistory";

export type HistoryEvent = PopStateEvent | PushStateEvent | ReplaceStateEvent;

/**
 * Add an event listener for all history state changes: popstate, pushstate, replacestate.
 */
export function onHistory(listener: (event: HistoryEvent) => void): void {
  window.addEventListener("popstate", listener);
  window.addEventListener("pushstate", listener);
  window.addEventListener("replacestate", listener);
}

/**
 * Remove an event listener for all history state changes: popstate, pushstate, replacestate.
 */
export function offHistory(listener: (event: HistoryEvent) => void): void {
  window.removeEventListener("popstate", listener);
  window.removeEventListener("pushstate", listener);
  window.removeEventListener("replacestate", listener);
}
